import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isInRangeValue, PortalFieldConfig, RangeValidatorError } from '@portal/form/data-access';

export function percentageValidator(control: AbstractControl): ValidationErrors | null {
  const valueString = control.value ? control.value.toString() : '';
  const value = parseFloat(valueString.replace(/,/g, ''));
  const maxValue = 100;
  if (value === null || value === undefined || isNaN(value) || value <= maxValue) {
    return null;
  }
  return { percentage: true };
}

export function rangeValidator(control: AbstractControl, field: PortalFieldConfig): RangeValidatorError | null {
  // Read the range from field props
  const range = field?.props?.range;

  // Use helper to check if current control value is in-range (treats empty/non-numeric as valid)
  const valid = isInRangeValue(control?.value, range);
  if (valid) {
    return null;
  }

  // At this point value is numeric and out-of-range; compute numeric and normalized min/max to return in the error
  const valueString = control?.value?.toString();
  const numeric = valueString ? parseFloat(valueString.replace(/,/g, '')) : NaN;

  let minVal = typeof range?.min === 'number' ? range.min : undefined;
  let maxVal = typeof range?.max === 'number' ? range.max : undefined;
  if (typeof minVal === 'number' && typeof maxVal === 'number' && minVal > maxVal) {
    const tmp = minVal;
    minVal = maxVal;
    maxVal = tmp;
  }

  return { range: { min: minVal, max: maxVal, actual: numeric } };
}
